import React from 'react';
import { LogoWhite } from '../assets/svg';

function CollapsedLogoComponent(props) {
  const { className } = props;
  return <LogoWhite className={className} />;
}
export default CollapsedLogoComponent;
